module.exports = __webpack_public_path__ + "static/media/to_left.afe61ac3.svg";